import { splitLines, splitWords, resetSplit } from './splitText'

const SELECTOR = '[data-motion]'

function prepare(el) {
	const mode = el.getAttribute('data-motion')
	if (mode === 'lines') splitLines(el)
	if (mode === 'words') splitWords(el)

	const delay = el.getAttribute('data-motion-delay')
	if (delay) el.style.setProperty('--motion-delay', `${parseInt(delay, 10)}ms`)
}

function watchResize(elements) {
	const splittable = elements.filter((el) => {
		const mode = el.getAttribute('data-motion')
		return mode === 'lines' || mode === 'words'
	})

	if (!splittable.length) return

	let lastWidth = window.innerWidth
	let timer = null

	window.addEventListener(
		'resize',
		() => {
			/* Ignore the height-only resizes mobile browsers fire while scrolling. */
			if (window.innerWidth === lastWidth) return
			lastWidth = window.innerWidth

			window.clearTimeout(timer)
			timer = window.setTimeout(() => {
				splittable.forEach((el) => {
					resetSplit(el)
					prepare(el)
				})
			}, 200)
		},
		{ passive: true }
	)
}

export default function initReveal() {
	const elements = Array.from(document.querySelectorAll(SELECTOR))
	if (!elements.length) return

	elements.forEach(prepare)

	if (!('IntersectionObserver' in window)) {
		elements.forEach((el) => el.classList.add('is-inview'))
		return
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return
				entry.target.classList.add('is-inview')
				observer.unobserve(entry.target)
			})
		},
		{ rootMargin: '0px 0px -12% 0px', threshold: 0 }
	)

	const revealNow = (els) => {
		requestAnimationFrame(() => {
			els.forEach((el) => el.classList.add('is-inview'))
		})
	}

	const heroEls = []
	const rest = []

	elements.forEach((el) => {
		if (el.closest('.section--hero')) {
			heroEls.push(el)
		} else {
			rest.push(el)
		}
	})

	/*
	 * Hero sits above the fold; the default bottom inset would hold the
	 * dock until you scroll. Fire with the opening sequence instead.
	 */
	if (heroEls.length) {
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(() => revealNow(heroEls)).catch(() => revealNow(heroEls))
		} else {
			revealNow(heroEls)
		}
	}

	rest.forEach((el) => observer.observe(el))

	watchResize(elements)
}
